<template>
  <svg
    :width="size"
    :height="Math.round(size * 1.1)"
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g xmlns="http://www.w3.org/2000/svg" fill="none" fill-rule="evenodd">
      <text fill="#FFF" font-family="FAZGoldSans-Regular, 'helvetica neue', helvetica, sans-serif" font-size="10">
        <tspan x="6.28" y="17">15</tspan>
      </text>
      <g fill-rule="nonzero">
        <path
          stroke="#FFF"
          d="M1.282 12.596c-.285 5.516 3.955 10.225 9.47 10.518a9.982 9.982 0 0 0 10.502-9.456c.285-5.515-3.955-10.224-9.47-10.517"
        />
        <path fill="#FFF" d="M8.4 3.75L11.9.6v6.3z" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 22,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>
